import axiosInstance from './axios';
import { API_URL } from '../config/api';

export const habitService = {
  getHabits: () => axiosInstance.get(`/api/habits`),
  createHabit: (data) => axiosInstance.post(`/api/habits`, data),
  updateHabit: (id, data) => axiosInstance.put(`/api/habits/${id}`, data),
  deleteHabit: (id) => axiosInstance.delete(`/api/habits/${id}`)
};